import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export class ConfirmationDialogData {
  showIcon: boolean = false;
  showCancelButton: boolean = true;
  header: string = 'Are you sure?';
  message: string;
  cancelActionText: string = 'Cancel';
  confirmActionText: string = 'Confirm';
  confirmButtonColor: string = 'primary';
}

@Component({
  selector: 'sd-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {}

  ngOnInit() {
    this.data = {
      ...new ConfirmationDialogData(),
      ...this.data
    };
  }
}
